<section class="error-page">
  <h1 class="error-page__code">403</h1>
  <p class="error-page__message">
    You do not have access to IOPOC. Access is restricted to members of the <strong>IO_POC_Users</strong> group.
  </p>
</section>
